import React, { FC, useContext } from 'react'
import { ShareIcon, CheckIcon, ChevronLeftIcon } from '@heroicons/react/outline'
import { Link } from 'react-router-dom'
import { userStore } from '../../../utils/UserContext'
import { Button } from '../../../System'
import { useCopyToClipboard } from '../../../utils/copyToClipboard'
import { StyledWorks } from '.'
import ROUTES from '../../../utils/routes'

const Subscription: FC = () => {
  const { user } = useContext(userStore)
  const {
    isCopied,
    actions: { copyToClipboard }
  } = useCopyToClipboard()
  const { origin } = window.location
  const affiliateUrl = `${origin}/a/${user?.id}`

  return (
    <StyledWorks>
      <div className="top-content">
        <Link to={ROUTES.affiliates.links}>
          <Button theme="outline" className="back-btn" isIcon>
            <ChevronLeftIcon />
          </Button>
        </Link>
        <div className="share-link-input-container">
          <span className="share-link-input-label">Share Link</span>
          <div className="share-link-input">
            <span>{affiliateUrl}</span>
            <Button
              iconPos="right"
              className="copy-link-btn"
              isDisabled={isCopied}
              onClick={() => copyToClipboard(affiliateUrl)}
            >
              {isCopied ? (
                <>
                  COPIED <CheckIcon />
                </>
              ) : (
                <>
                  COPY LINK <ShareIcon />
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
      <div className="heading">
        <h2>Social Curator Subscription Payout Details</h2>
        <p>
          Every time someone uses your link to sign up for a paid subscription, you'll both receive
          benefits.
        </p>
      </div>
      <div className="payout-details">
        <h3>
          <b>You</b> receive a one-time payment of:
        </h3>
        <div className="payout-detail-grid">
          <div className="payout-detail">
            <div className="work-step-number">
              <span>1</span>
            </div>
            <b>$49</b>
            <span>per new monthly subscription</span>
          </div>
          <div className="payout-detail">
            <div className="work-step-number">
              <span>2</span>
            </div>
            <b>$75</b>
            <span>per new annual subscription</span>
          </div>
        </div>
        <span className="payout-details-disclaimer">
          If they sign up for a trial first and then upgrade to a paid monthly or annual account,
          you’ll receive the same payout listed above.
        </span>
      </div>
      <div className="payout-details">
        <h3>
          <b>They</b> receive a discount of:
        </h3>
        <div className="payout-detail-grid">
          <div className="payout-detail">
            <div className="work-step-number">
              <span>1</span>
            </div>
            <b>$15 off</b>
            <span>their first month</span>
          </div>
          <div className="payout-detail">
            <div className="work-step-number">
              <span>2</span>
            </div>
            <b>$50 off</b>
            <span>their first year</span>
          </div>
        </div>
      </div>
    </StyledWorks>
  )
}

export default Subscription
